import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Define patterns for custom classes that should be preserved
// This approach is more scalable than hardcoding individual class names
const CUSTOM_CLASS_PATTERNS = [
  // Custom font classes
  /^font-(functional|display)$/,
  // Custom font-size classes
  /^font-size-/,
  // Custom leading (line-height) classes
  /^leading-(00|25|50|75|100|200|300|400|500|600|700|800|900|1000|1100)$/,
  // Custom text utility classes (text-display, text-heading, text-body, text-caption variants)
  /^text-(display|heading|body|caption)(-\w+)?(-\w+)?$/,
  // Text weight classes
  /^text-weight-/,
  // Text color classes
  /^text-color-/,
  /^outline-width-/,
  /^border-width-/,
  // Custom spacing classes (example)
  // /^spacing-(xs|sm|md|lg|xl)$/,
  // Custom color classes (example)
  // /^color-(primary|secondary|accent)$/,
  // Any class that starts with 'custom-'
  /^custom-/,
];

function isCustomClass(className: string): boolean {
  return CUSTOM_CLASS_PATTERNS.some((pattern) => pattern.test(className));
}

export function cn(...inputs: ClassValue[]) {
  // Use clsx first to combine classes, then use twMerge for standard Tailwind classes
  const combined = clsx(inputs);

  // Split classes and filter out our custom classes before merging
  const classes = combined.split(" ");
  const customClasses = classes.filter((cls) => isCustomClass(cls));
  const standardClasses = classes.filter((cls) => !isCustomClass(cls));

  // Merge standard classes and add back custom classes
  const mergedStandard = twMerge(standardClasses.join(" "));

  return clsx(mergedStandard, customClasses);
}
